// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__7Yfsm","bigColWidth":"Table_bigColWidth__2wwhc","biggerColWidth":"Table_biggerColWidth__W_22w","row":"Table_row__ly-94","col":"Table_col__1cBEp"};